import useAuth from '../../component/useAuth';

import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { useNavigate, Link } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



export default function EmailUpdate() {

  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
   
    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);

      // Clean up timer
      return () => clearInterval(timer);
    } else {
     
      navigate("/college/examverification");
      setLoading(true);
    }
  }, [countdown,navigate]);


  //validating user credintial again to ensure he is loged in 
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/")
  }

  const { http } = Api();
  const [paymentmsg, setPaymentMsg] = useState('false');
  const [amount, setAmount] = useState('');
  const [transactionId, setTransactionId] = useState('');


  useEffect(() => {

    http.get(`College/paymentReceipt`, {

      params: {
        examid: sessionStorage.getItem('eaxm_id'),
        txnid: sessionStorage.getItem('transaction_id'),
      }

    }).then(response => {

      console.log(response);

      if (response.data.Status === "SUCCESS") {
        setPaymentMsg('success');
        setAmount(response.data.amt);
        setTransactionId(response.data.transId);

      }
      else if (response.data.Status === "failure" || response.data.Status === "Cancelled" || response.data.Status === "FAILED") {
        setPaymentMsg('failure');

      }
      else if (response.data.Status === "PENDING") {
        setPaymentMsg('pending');

      }

    }).catch(error => {

      console.log(error);


    });

    try {
      http.get('/College/paymentReceiptPdf', {
        params: {
          examid: sessionStorage.getItem('eaxm_id'),
          txnid: sessionStorage.getItem('transaction_id'),
        },
        responseType: 'blob',
      }).then(response => {

        if (response && response.data) {
          // Create a URL for the downloaded file
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          // Set the file name and download the PDF
          link.setAttribute('download', `${localStorage.getItem('username')}_RECEIPT.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          return Promise.resolve('PDF generated successfully');
        }
      })



    } catch (error) {
      console.error('Error generating PDF:', error);
      return Promise.reject('Error generating PDF');
    }


  }, []);



  return (
    <>
      <ToastContainer /> {/*  to display toast */}
      {paymentmsg === 'success' ? (
        <div className="success-page">
          <body>
            <div class="container">
              <div class="printer-top"></div>
              <div class="paper-container">
                <div class="paper">
                  <div class="success-icon">
                    <span>&#10004;</span>
                  </div>
                  <div class="success-title">
                    ₹{amount}
                  </div>
                  <div class="success-title">
                    Payment Complete
                  </div>
                  <div class="success-description">
                    Thank you for completing the payment! Check the Receipt for more details.
                  </div>
                  <div class="order-details">
                    <div class="order-number-label">Transaction ID</div>
                    <div class="order-number">{transactionId}</div>
                  </div>
                  <div class="warning">
                    Please do not go back or refresh this page.
                  </div>
                  {!loading ? (
                  <div class="countdown">
                    Redirecting in <span>{countdown}</span> seconds...
                  </div>
                  ):(
                    <div id="countdown " className='text-center'>
                      <Link to="/college/examverification" className="text-center">
                        Click here if you are not redirected
                      </Link>
                    </div>
                  )}

                </div>
              </div>
            </div>




          </body>
        </div>
      ) : paymentmsg === 'failure' ? (
        <div className="failure-page">
          <body>
            <div class="container">
              <div class="printer-top"></div>
              <div class="paper-container">
                <div class="paper">
                  <div class="failure-icon">
                    <span>&#10008;</span>
                  </div>
                  <div class="failure-title">
                    Payment Failed
                  </div>
                  <div class="failure-description">
                    We're sorry, but your payment could not be processed. Please check your payment details and try again.
                  </div>
                  <div class="transaction-details">

                    <div class="retry-message">Please Try Again</div>
                  </div>
                  <div class="warning">
                    Please do not go back or refresh this page.
                  </div>
                  {!loading ? (
                  <div class="countdown">
                    Redirecting in <span>{countdown}</span> seconds...
                  </div>
                  ):(
                    <div id="countdown " className='text-center'>
                      <Link to="/college/examverification" className="text-center">
                        Click here if you are not redirected
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>



          </body>
        </div>
      ) : paymentmsg === 'pending' && (
        <div className='pending-page'>
          <body>
            <div class="container">
              <div class="printer-top"></div>
              <div class="paper-container">
                <div class="paper">
                  <div class="pending-icon">
                    <span>&#8987;</span>
                  </div>
                  <div class="pending-title">
                    Payment Pending
                  </div>
                  <div class="pending-description">
                    <strong>This may take a few moments. Check the Receipt for more details.</strong>
                  </div>
                  <div class="transaction-details">
                 
                    <div class="status-message">Processing...</div>
                  </div>

                  {!loading ? (
                  <div class="countdown">
                    Redirecting in <span>{countdown}</span> seconds...
                  </div>
                  ):(
                    <div id="countdown " className='text-center'>
                      <Link to="/college/examverification" className="text-center">
                        Click here if you are not redirected
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>




          </body>
        </div>
      )}
    </>
  );
}
